import { ChangeDetectionStrategy, Component, effect, inject, Input } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { map } from 'rxjs';
import { dateFormat, Plan } from '../../../core';
import { UserService } from '../../../services';
import { AnatomicalSideLabelPipe, BaseComponent, BoneTypeLabelPipe, ConvertDatePipe } from '../../../shared';


/**
 * Template page of PDF print.
 */
@Component({
	selector: 'prt-template',
	templateUrl: './prt-template.component.html',
	imports: [
		ConvertDatePipe,
		BoneTypeLabelPipe,
		AnatomicalSideLabelPipe
	],
	changeDetection: ChangeDetectionStrategy.Eager,
})
export class PrtTemplateComponent extends BaseComponent {

	private readonly userSrv = inject(UserService);

	@Input() today: Date | null = null;

	currentCase?: Plan;
	drFullName = toSignal(this.userSrv.getUserName().pipe(map(name => name.firstName + ' ' + name.lastName)));
	isDemo = toSignal(this.userSrv.isDemoUser());

	readonly dateFormat = dateFormat();

	private readonly _init = effect(() => this.currentCase = this.canvasSrv.currentCase);

}
